import type dayjs from 'dayjs'
import { NAMESPACE } from 'locale'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import type { RangeValue } from 'types/shared'
import { goalReportsConstants } from '../../../../../locale/goalReports'
import type { FilterValues } from '../types'

type ContentType = RangeValue<dayjs.Dayjs> | string[]

export interface Filter {
  [key: string]: ContentType
}

interface SelectedFiltersProps {
  selectedFilters: Filter
}

type FilterKeys = keyof FilterValues
type FilterKeyTitle = Record<FilterKeys, string>

export const GoalSelectedFilters = ({
  selectedFilters
}: SelectedFiltersProps) => {
  const { t } = useTranslation(NAMESPACE.GOAL_REPORTS)
  const filterKeyTitle: Partial<FilterKeyTitle> = {
    residents: t(goalReportsConstants.FILTER_RESIDENTS),
    goalStatuses: t(goalReportsConstants.GOAL_STATUS),
    reviewStatuses: t(goalReportsConstants.REVIEW_STATUS)
  }

  if (!selectedFilters || Object.keys(selectedFilters).length === 0) {
    return <FilteredText>{t(goalReportsConstants.NO_FILTERS)}</FilteredText>
  }

  return (
    <div>
      <FilteredText>{t(goalReportsConstants.FILTERED_BY)} </FilteredText>
      {Object.entries(selectedFilters).map(([key, value], index) => (
        <Fragment key={key}>
          <FilteredText>{`${
            filterKeyTitle[key as FilterKeys]
          } - `}</FilteredText>
          <FilteredTextDark>
            {typeof value === 'string' ? value : (value as string[]).join(', ')}
            {index !== Object.keys(selectedFilters).length - 1 && (
              <FilteredText> {t(goalReportsConstants.AND_BY)} </FilteredText>
            )}
          </FilteredTextDark>
        </Fragment>
      ))}
    </div>
  )
}

const BaseFilteredText = styled.span`
  font-family: ${(props) => props.theme.font.family.sansSerif};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`

const FilteredText = styled(BaseFilteredText)`
  color: ${(props) => props.theme.color.neutral.color5};
`

const FilteredTextDark = styled(BaseFilteredText)`
  color: ${(props) => props.theme.color.neutral.color4};
`
